//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import moment from 'moment-timezone'

import schedulePosts from '@/graphql/mutations/submissions/schedulePosts.gql'
import updateScheduledPosts from '@/graphql/mutations/submissions/updateScheduledPosts.gql'
import nextScheduleDates from '@/graphql/queries/socialaccounts/nextScheduleDates.gql'

import IntroModal from '@/components/createPost/IntroModal.vue'

import { uuidv4 } from '@/lib/utils'
import { handleBackendValidationErrors } from '@/lib/validation'
import { getPlatform } from '@/lib/platforms'

export default {
  name: 'CreatePostPage',
  props: {
    /** Editing props */
    postId: {
      type: String,
      required: false
    },
    postPlatform: {
      type: String,
      required: false
    },
    /** Create from post */
    fromPost: {
      type: Object,
      default: null,
      required: false
    },
    /** Create from media */
    media: {
      type: Object,
      required: false
    },
    /** Create from social accounts */
    socialAccounts: {
      type: Array,
      required: false
    },
    /** Create for date */
    date: {
      type: String,
      required: false
    },
    /** When present, a social account for this platform will be selected automatically. */
    createForPlatform: {
      type: String,
      required: false
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: !!this.postId,
      selectedPostId: null,
      accountPosts: [],
      isScheduling: false,
      postIsDraft: false,
      customScheduleDates: [],
      fromPostValue: this.fromPost,
      hasUpdatedAnyPost: false
    }
  },
  methods: {
    submitForm(publishingStatus = 'READY_TO_PUBLISH') {
      // Handle situation where we don't call schedulePosts from the template,
      // so the first argument is the event object.
      if (typeof publishingStatus !== 'string') {
        publishingStatus = 'READY_TO_PUBLISH'
      }

      if (this.isEdit) {
        this.updateScheduledPosts(publishingStatus)
      } else {
        this.schedulePosts(publishingStatus)
      }
    },
    submitNow() {
      this.$buefy.dialog.confirm({
        title: 'Submit Now',
        message: `Are you sure you want to submit ${
          this.accountPosts.length === 1 ? 'this post' : 'these posts'
        } now? ${
          this.accountPosts.length === 1 ? 'It' : 'They'
        } will be published immediately.`,
        confirmText: 'Submit Now',
        type: 'is-primary',
        onConfirm: () => {
          if (this.isEdit) {
            this.updateScheduledPosts('DRAFT', true)
          } else {
            this.schedulePosts('DRAFT', true)
          }
        }
      })
    },
    schedulePosts(
      publishingStatus = 'READY_TO_PUBLISH',
      submitImmediately = false
    ) {
      this.isScheduling = true

      if (submitImmediately) {
        // Set postAt to one hour from now so that the posts never fail validation.
        this.accountPosts.forEach((accountPost) => {
          const platform = getPlatform(accountPost.platform)
          accountPost.post = platform.posts.syncField(
            accountPost.post,
            'postAt',
            moment().add(1, 'hour').toDate()
          )
        })
      }

      let posts = this.accountPosts.map((accountPost) => {
        const platform = getPlatform(accountPost.platform)
        let post = accountPost.post
        post = platform.posts.preparePostForScheduling(post, publishingStatus)
        return {
          validationId: accountPost.$id,
          [platform.code]: post
        }
      })
      const uniquePlatforms = new Set(
        this.accountPosts.map((post) => post.platform)
      )

      this.$apollo
        .mutate({
          mutation: schedulePosts,
          variables: {
            posts
          }
        })
        .then(async (response) => {
          if (response.data.schedulePosts.success) {
            if (submitImmediately) {
              // Handle immediate submission logic
              const createdPosts = response.data.schedulePosts.createdPosts
              await this.submitPosts(createdPosts)
            } else {
              // Handle regular scheduling success
              const isDraft = publishingStatus === 'DRAFT'
              const message = isDraft
                ? `Saved ${this.accountPosts.length} post${
                    this.accountPosts.length > 1 ? 's' : ''
                  } as Draft.`
                : `Scheduled ${this.accountPosts.length} post${
                    this.accountPosts.length > 1 ? 's' : ''
                  }!`

              this.$buefy.snackbar.open({
                message,
                type: 'is-success',
                position: 'is-top',
                duration: 4000,
                pauseOnHover: true
              })
            }

            this.$store.dispatch('getProfile')
            this.$emit('close', Array.from(uniquePlatforms))
          } else if (response.data.schedulePosts.errors.length) {
            handleBackendValidationErrors(response.data.schedulePosts.errors)
          } else if (response.data.schedulePosts.postErrors.length) {
            let countPostsWithErrors = 0
            this.accountPosts.forEach((accountPost) => {
              const postError = response.data.schedulePosts.postErrors.find(
                (error) => error.validationId === accountPost.$id
              )
              if (postError) {
                countPostsWithErrors++
                accountPost.errors = postError.errors
              } else {
                accountPost.errors = []
              }
            })
            if (countPostsWithErrors > 0) {
              this.$buefy.snackbar.open({
                message: `${countPostsWithErrors} post${
                  countPostsWithErrors !== 1 ? 's' : ''
                } contain errors. Please fix ${
                  countPostsWithErrors !== 1 ? 'them' : 'the post'
                } before scheduling.`,
                type: 'is-danger',
                position: 'is-top',
                duration: 4000,
                pauseOnHover: true
              })
            }
          }
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.isScheduling = false
        })
    },
    updateScheduledPosts(
      publishingStatus = 'READY_TO_PUBLISH',
      submitImmediately = false
    ) {
      // Handle situation where we don't call schedulePosts from the template,
      // so the first argument is the event object.
      if (typeof publishingStatus !== 'string') {
        publishingStatus = 'READY_TO_PUBLISH'
      }

      this.isScheduling = true

      if (submitImmediately) {
        // Set postAt to one hour from now so that the posts never fail validation.
        this.accountPosts.forEach((accountPost) => {
          const platform = getPlatform(accountPost.platform)
          accountPost.post = platform.posts.syncField(
            accountPost.post,
            'postAt',
            moment().add(1, 'hour').toDate()
          )
        })
      }

      let posts = this.accountPosts.map((accountPost) => {
        const platform = getPlatform(accountPost.platform)
        let post = accountPost.post
        post = platform.posts.preparePostForScheduling(post, publishingStatus)
        return {
          validationId: accountPost.$id,
          [platform.code]: post
        }
      })
      const uniquePlatforms = new Set(
        this.accountPosts.map((post) => post.platform)
      )

      this.$apollo
        .mutate({
          mutation: updateScheduledPosts,
          variables: {
            posts
          }
        })
        .then(async (response) => {
          if (response.data.updateScheduledPosts.success) {
            if (submitImmediately) {
              // Handle immediate submission logic
              const updatedPosts =
                response.data.updateScheduledPosts.updatedPosts
              await this.submitPosts(updatedPosts)
            } else {
              // Handle regular scheduling success
              const isDraft = publishingStatus === 'DRAFT'
              const message = isDraft
                ? 'Saved post as a Draft.'
                : 'Post successfully updated!'

              this.$buefy.snackbar.open({
                message,
                type: 'is-success',
                position: 'is-top',
                duration: 4000,
                pauseOnHover: true
              })
            }

            this.$store.dispatch('getProfile')
            this.$emit('close', uniquePlatforms)
          } else if (response.data.updateScheduledPosts.errors.length) {
            handleBackendValidationErrors(
              response.data.updateScheduledPosts.errors
            )
          } else if (response.data.updateScheduledPosts.postErrors.length) {
            let countPostsWithErrors = 0
            this.accountPosts.forEach((accountPost) => {
              const postError =
                response.data.updateScheduledPosts.postErrors.find(
                  (error) => error.validationId === accountPost.$id
                )
              if (postError) {
                countPostsWithErrors++
                accountPost.errors = postError.errors
              } else {
                accountPost.errors = []
              }
            })
            if (countPostsWithErrors > 0) {
              this.$buefy.snackbar.open({
                message:
                  'Post contains errors. Please fix it before scheduling.',
                type: 'is-danger',
                position: 'is-top',
                duration: 4000,
                pauseOnHover: true
              })
            }
          }
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.isScheduling = false
        })
    },
    async submitPosts(posts) {
      const submitResults = await Promise.all(
        posts.map(async (post) => {
          const platform = getPlatform(post.platform.toLowerCase())
          const result = await this.$apollo.mutate({
            mutation: platform.mutations.submitPost,
            variables: {
              postId: post.id,
              platform: post.platform.toUpperCase()
            }
          })
          return { platform, result }
        })
      )

      // Process submission results
      let successCount = 0
      let errorMessages = []

      submitResults.forEach(({ platform, result }) => {
        const mutationName =
          platform.mutations.submitPost.definitions[0].name.value
        if (result.data[mutationName].success) {
          successCount++
        } else {
          let submissionError = result.data[mutationName].submissionError
          if (result.data[mutationName].errors?.length) {
            handleBackendErrors(result.data[mutationName].errors)
          } else {
            errorMessages.push(
              `${platform.name} post failed: ${submissionError.message}`
            )
          }
        }
      })

      let message = `Successfully submitted ${successCount} ${
        successCount === 1 ? 'post' : 'posts'
      }.`
      if (errorMessages.length > 0) {
        message += ` ${errorMessages.join('. ')}`
      }

      this.$buefy.snackbar.open({
        message,
        type: errorMessages.length > 0 ? 'is-warning' : 'is-success',
        position: 'is-top',
        duration: errorMessages.length > 0 ? 6000 : 4000,
        pauseOnHover: true
      })
    },
    async fetchPostToEdit() {
      let platform = getPlatform(this.postPlatform)
      let query = platform.queries.getPost
      let queryName = query.definitions[0].name.value

      const response = await this.$apollo.query({
        query,
        variables: {
          id: this.postId
        },
        fetchPolicy: 'network-only'
      })

      if (response.data[queryName]) {
        let post = response.data[queryName]

        this.postIsDraft = post.publishingStatus === 'DRAFT'

        let socialAccount = this.$store.state.profile.socialAccounts.find(
          (account) => account.id === post.socialAccount.id
        )
        let accountPost = this.newAccountPost(
          socialAccount.platform.toLowerCase(),
          post,
          socialAccount
        )
        this.accountPosts.push(accountPost)
        this.handleSelectedPost(accountPost)
      } else {
        this.$buefy.snackbar.open({
          message: `${platform.name} ${platform.postNoun} not found.`,
          type: 'is-danger',
          position: 'is-top',
          duration: 4000,
          pauseOnHover: true
        })
      }
    },
    async addSocialAccounts(socialAccounts) {
      await this.loadCustomScheduleDates(socialAccounts)

      let firstAddedPost = null

      for (const socialAccount of socialAccounts) {
        let addedPost = this.addSocialAccount(socialAccount)

        this.handleInitializedPost(addedPost)

        if (this.media) {
          this.syncMediaToPost(addedPost)
        }

        if (!firstAddedPost) {
          firstAddedPost = addedPost
        }

        // Don't auto-schedule based on account schedule if we are creating a
        // post from a date (from Scheduled Posts).
        if (!this.date) {
          // Use a custom schedule date, if available.
          let customScheduleDate = this.customScheduleDates.find(
            (date) => date.socialAccountId === socialAccount.id
          )
          if (customScheduleDate && customScheduleDate.scheduleDate) {
            getPlatform(addedPost.platform).posts.syncField(
              addedPost.post,
              'postAt',
              new Date(customScheduleDate.scheduleDate)
            )
            addedPost.isAutoScheduled = true
          }
        }
      }

      if (this.date) {
        const date = moment(this.date).hour(10).toDate()
        this.syncField('postAt', date)
      }

      this.handleSelectedPost(firstAddedPost)

      if (this.fromPostValue) {
        // Reset fromPostValue so that new posts don't sync with it.
        this.fromPostValue = null
      }
    },
    addSocialAccount(socialAccount) {
      let platform = getPlatform(socialAccount.platform)
      let post = null
      if (platform.posts.createPost) {
        post = platform.posts.createPost(socialAccount)
      }

      let accountPost = this.newAccountPost(
        socialAccount.platform.toLowerCase(),
        post,
        socialAccount
      )
      this.accountPosts.push(accountPost)

      return accountPost
    },
    newAccountPost(platform, post, socialAccount, isAutoScheduled = false) {
      return {
        $id: uuidv4(),
        platform,
        post,
        socialAccount,
        isAutoScheduled,
        errors: []
      }
    },
    /**
     * Syncs the newly initialized post with data from the first post.
     */
    handleInitializedPost(accountPost) {
      let accountPostPlatform = getPlatform(accountPost.platform)

      let syncFrom
      if (this.fromPostValue) {
        syncFrom = this.newAccountPost(
          this.fromPostValue.platform,
          this.fromPostValue
        )
      } else {
        syncFrom = this.accountPosts.find(
          (post) => post.$id !== accountPost.$id
        )
      }

      if (syncFrom) {
        let syncFromPlatform = getPlatform(syncFrom.platform)
        if (!syncFromPlatform.posts.getPost) {
          return
        }
        let syncFromPost = syncFromPlatform.posts.getPost(syncFrom.post)

        if (accountPostPlatform.posts.syncField) {
          const isThreadedPlatform = [
            'twitter',
            'threads',
            'bluesky',
            'mastodon'
          ].includes(syncFromPlatform.code)

          if (isThreadedPlatform) {
            accountPost.post = accountPostPlatform.posts.syncField(
              accountPost.post,
              'thread',
              syncFromPost.thread
            )
          } else {
            Object.entries(syncFromPost).forEach(([field, value]) => {
              if (!value) {
                return
              }
              accountPost.post = accountPostPlatform.posts.syncField(
                accountPost.post,
                field,
                value
              )
            })
          }
        }
      }
    },
    syncMediaToPost(accountPost) {
      let accountPostPlatform = getPlatform(accountPost.platform)
      if (this.media) {
        if (accountPostPlatform.posts.syncField) {
          let gallery = {
            id: null,
            galleryMediaSet: [
              {
                order: 0,
                media: this.media
              }
            ]
          }
          accountPost.post = accountPostPlatform.posts.syncField(
            accountPost.post,
            'gallery',
            gallery
          )
        }
      }
    },
    handleUpdatedPost(post, isUpdated) {
      this.hasUpdatedAnyPost = this.hasUpdatedAnyPost || isUpdated
      let accountPost = this.accountPosts.find(
        (post) => post.$id === this.selectedAccountPost.$id
      )
      accountPost.post = post
      accountPost.errors = []
    },
    handleSelectedPost(post) {
      if (
        this.accountPosts.some((accountPost) => accountPost.$id === post.$id)
      ) {
        this.selectedPostId = post.$id
      }
    },
    handleSelectedAccount(socialAccount) {
      if (
        this.accountPosts.length > 0 &&
        this.accountPosts[0].post.hasOwnProperty('username')
      ) {
        this.accountPosts[0].socialAccount = socialAccount
        this.accountPosts[0].post.username = socialAccount.username
      }
    },
    handleRemovePost(post) {
      const isRemovingSelectedPost = post.$id === this.selectedPostId

      let index = this.accountPosts.findIndex((p) => p.$id === post.$id)
      this.accountPosts.splice(index, 1)

      if (isRemovingSelectedPost && this.accountPosts.length > 0) {
        let nextPost = null
        if (index === 0) {
          // If the first post was removed, select the new first post
          nextPost = this.accountPosts[0]
        } else if (this.accountPosts.length === index) {
          // If the last post was removed, select the new last post
          nextPost = this.accountPosts[index - 1]
        } else {
          // Select the next post
          nextPost = this.accountPosts[index]
        }
        this.handleSelectedPost(nextPost)
      }
    },
    manualSyncField(field, value) {
      this.syncField(field, value)

      const fieldNames = {
        caption: 'Caption',
        text: 'Text',
        thread: 'Thread',
        gallery: 'Media',
        postAt: 'Scheduled date & time'
      }
      this.$buefy.snackbar.open({
        message: `${fieldNames[field]} synced to all posts!`,
        type: 'is-success',
        position: 'is-top',
        duration: 2000,
        pauseOnHover: true
      })
    },
    /**
     * Possible syncable fields:
     * - caption
     * - text (not implemented)
     * - gallery
     * - postAt
     */
    syncField(field, value) {
      this.accountPosts.forEach((accountPost) => {
        if (accountPost.$id === this.selectedPostId) {
          return
        }
        const platform = getPlatform(accountPost.platform)
        if (platform.posts.syncField) {
          accountPost.post = platform.posts.syncField(
            accountPost.post,
            field,
            value
          )
          // Assume that fixed whatever errors were present.
          accountPost.errors = []
        }
      })
    },
    syncMediaCover(media) {
      this.accountPosts.forEach((accountPost) => {
        if (accountPost.$id === this.selectedPostId) {
          return
        }
        const platform = getPlatform(accountPost.platform)
        if (platform.posts.syncCoverImage) {
          accountPost.post = platform.posts.syncCoverImage(
            accountPost.post,
            media
          )
        }
      })
    },
    handleClosePage() {
      // Display a confirmation dialog
      if (this.accountPosts.length === 0 || !this.hasUpdatedAnyPost) {
        this.$emit('close')
      } else {
        this.$buefy.dialog.confirm({
          title: 'Are you sure?',
          message:
            "Any changes you've made will be lost. This cannot be undone.",
          confirmText: 'Discard Changes',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.$emit('close')
          }
        })
      }
    },
    scrollToTop() {
      this.$refs.createPostForm.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    scrollToAccounts() {
      this.$refs.createPostAccounts.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    async loadCustomScheduleDates(socialAccounts) {
      if (!socialAccounts || socialAccounts.length === 0) {
        return
      }

      // Only fetch the schedule dates for accounts that are not already in customScheduleDates.
      const socialAccountIds = socialAccounts
        .map((socialAccount) => socialAccount.id)
        .filter(
          (id) =>
            !this.customScheduleDates.find(
              (date) => date.socialAccountId === id
            )
        )
      if (socialAccountIds.length === 0) {
        return
      }

      let response = await this.$apollo.query({
        query: nextScheduleDates,
        variables: { socialAccountIds },
        fetchPolicy: 'network-only'
      })
      if (response.data.nextScheduleDates) {
        this.customScheduleDates = [
          ...this.customScheduleDates,
          ...response.data.nextScheduleDates
        ]
      }
    },
    displayIntroModal() {
      this.$buefy.modal.open({
        parent: this,
        component: IntroModal,
        hasModalCard: true,
        destroyOnHide: true
      })
    }
  },
  computed: {
    ...mapGetters(['totalAccounts']),
    selectedPlatform() {
      if (!this.selectedAccountPost) {
        return null
      } else {
        return getPlatform(this.selectedAccountPost.platform)
      }
    },
    selectedPost() {
      if (!this.selectedAccountPost) {
        return null
      } else {
        return this.selectedAccountPost.post
      }
    },
    selectedAccountPost() {
      return this.accountPosts.find((post) => post.$id === this.selectedPostId)
    },
    selectedSocialAccount() {
      return this.selectedAccountPost
        ? this.selectedAccountPost.socialAccount
        : null
    },
    selectedSocialAccounts() {
      return this.accountPosts.map((post) => post.socialAccount)
    },
    numberOfPostsWithErrors() {
      return this.accountPosts.filter((post) => post.errors.length > 0).length
    }
  },
  async mounted() {
    // Automatically open the accounter picker any time the Page is not
    // displayed with an account already selected.
    let shouldOpenAccountsPicker = true

    if (this.isEdit) {
      this.fetchPostToEdit()
      shouldOpenAccountsPicker = false
    }
    await this.loadCustomScheduleDates(this.socialAccounts)

    if (this.socialAccounts) {
      this.addSocialAccounts(this.socialAccounts)
      shouldOpenAccountsPicker = false
    }

    if (this.createForPlatform) {
      let platformSocialAccounts =
        this.$store.state.profile.socialAccounts.filter(
          (account) =>
            account.platform.toLowerCase() ===
            this.createForPlatform.toLowerCase()
        )
      if (platformSocialAccounts.length === 1) {
        this.addSocialAccounts(platformSocialAccounts)
        shouldOpenAccountsPicker = false
      }
    }

    if (shouldOpenAccountsPicker) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.accountsPicker) {
            this.$refs.accountsPicker.open()
          }
        }, 200)
      })
    }

    try {
      // https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
      const el = this.$refs['page-header']
      const observer = new IntersectionObserver(
        ([e]) =>
          e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
        { threshold: [1] }
      )
      observer.observe(el)
    } catch (error) {
      console.error(error)
    }
  }
}
